import { ACTION_LIST } from "../../../models/role/action";
import { SUBJECT_CIRCUIT_BREAKER } from "../../../models/role/subject";
import { lazyRetry } from "../../../utils/lazyRetry";
import { PAGE_URLS } from "../constants/PageUrls";

import type { ComponentType } from "react";
import type { Route } from "../../../routes/RouteModel";

const BlocklistProxy = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CircuitBreakerProxy" */
      "../pages"
    ),
  "CircuitBreakerProxy",
  (module: { BlocklistProxy: ComponentType<any> }) => ({
    default: module.BlocklistProxy,
  })
);

export const blocklistRoute: Route = {
  i18nName: "Blocklist",
  newTheme: true,
  path: PAGE_URLS.blocklist,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_CIRCUIT_BREAKER,
  },
  component: BlocklistProxy,
};
